import { PROJECTS } from "@/data/projects";
import { SITE, url } from "@/data/site";
import PageShell from "@/components/PageShell";
import ProjectCard from "@/components/ProjectCard";
import { PageTitle, Section } from "@/components/shared/Primitives";

const CANONICAL = url("/work");

const JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      name: "Work — Elentara",
      url: CANONICAL,
      description:
        "Case studies and self-initiated concepts from Elentara, a creative technology studio.",
      isPartOf: { "@id": `${SITE.base}/#website` },
      about: { "@id": `${SITE.base}/#organization` },
      mainEntity: {
        "@type": "ItemList",
        itemListElement: PROJECTS.map((p, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: p.title,
          url: url(`/work/${p.slug}`),
        })),
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Elentara", item: url("/") },
        { "@type": "ListItem", position: 2, name: "Work", item: CANONICAL },
      ],
    },
  ],
};

const WORK_SEO = {
  title: "Work — Case Studies & Concepts | Elentara Creative Technology Studio",
  description:
    "Selected work from Elentara: immersive web case studies and self-initiated creative technology concepts across 3D, spatial computing and interactive systems.",
  canonical: CANONICAL,
  image: PROJECTS[0].image,
  jsonLd: JSON_LD,
};

export default function Work() {
  return (
    <PageShell
      testId="work-page"
      finalCtaFrom="work"
      seo={WORK_SEO}
    >
      <Section testId="work-hero" className="!pt-36 !pb-16">
        <PageTitle
          overline="Selected Work"
          testId="work-title"
          title="Work"
          lead="Case studies and self-initiated concepts. Every conceptual project is labelled — nothing here implies work made for a client that wasn't."
        />
      </Section>
      <Section testId="work-grid" className="!pt-0">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-10">
          {PROJECTS.map((project, i) => (
            <ProjectCard key={project.slug} project={project} index={i} offset />
          ))}
        </div>
      </Section>
    </PageShell>
  );
}
